import { render } from "./TransferDetail.vue?vue&type=template&id=69a77555&scoped=true"
import script from "./TransferDetail.vue?vue&type=script&lang=js"
export * from "./TransferDetail.vue?vue&type=script&lang=js"

import "./TransferDetail.vue?vue&type=style&index=0&id=69a77555&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a77555"]])

export default __exports__